enum SearchActions {
	FirstKeywordSearch = 'FirstKeywordSearch',
	NextKeywordSearch = 'NextKeywordSearch',
	DeleteKeywordSearch = 'DeleteKeywordSearch',
}

export default SearchActions;
